/*
=========================================================
* Material Kit 2 React - v2.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-kit-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// @mui material components
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";

// Material Kit 2 React components
import MKBox from "components/MKBox";
import MKTypography from "components/MKTypography";

// Material Kit 2 React examples
import HorizontalTeamCard from "parts/Cards/TeamCards/HorizontalTeamCard";

// Images
import team1 from "assets/images/6.jpg";
import team2 from "assets/images/22.jpg";
import team3 from "assets/images/16.jpg";
import team4 from "assets/images/35.jpg";

function Team() {
  return (
    <MKBox
      component="section"
      variant="gradient"
      bgColor="info"
      position="relative"
      py={6}
      px={{ xs: 2, lg: 0 }}
      mx={-2}
    >
      <Container>
        <Grid container>
          <Grid item xs={12} md={8} sx={{ mb: 6 }}>
            <MKTypography variant="h3" color="white">
            Why Choose Our Website Development & Maintenance Services?
            </MKTypography>
            <MKTypography variant="body2" color="white" opacity={0.8}>
  At HP Tech Solutions, we go beyond just creating websites—we build digital experiences. Our mission is to deliver innovative, secure, and scalable web development and maintenance solutions that empower businesses to thrive in an ever-changing online landscape.

  Backed by a team of experienced professionals, we specialize in designing custom websites, optimizing performance, and implementing robust security measures. Whether it's creating a new site from scratch or maintaining and enhancing an existing platform, we provide end-to-end services tailored to meet your unique business needs.
</MKTypography>

          </Grid>
        </Grid>
        <Grid container spacing={3}>
          <Grid item xs={12} lg={6}>
            <MKBox mb={1}>
              <HorizontalTeamCard
                image={team1}
                name="End-to-End Solutions"
                position={{ color: "info", label: "user-friendly" }}
                description="From the frontend user interface to the backend server-side logic, we handle all aspects of website and application development."
              />
            </MKBox>
          </Grid>
          <Grid item xs={12} lg={6}>
            <MKBox mb={1}>
              <HorizontalTeamCard
                image={team2}
                name="Scalable & Secure Architecture"
                position={{ color: "info", label: "Secure" }}
                description="We design systems that grow with your business and provide robust security for sensitive data."
              />
            </MKBox>
          </Grid>
          <Grid item xs={12} lg={6}>
            <MKBox mb={{ xs: 1, lg: 0 }}>
              <HorizontalTeamCard
                image={team3}
                name="Performance-First Approach"
                position={{ color: "info", label: "specific business goals" }}
                description="Optimized for speed, efficiency, and reliability to handle heavy traffic and ensure top performance."
              />
            </MKBox>
          </Grid>
          <Grid item xs={12} lg={6}>
            <MKBox mb={{ xs: 1, lg: 0 }}>
              <HorizontalTeamCard
                image={team4}
                name="Long-Term Sustainability"
                position={{ color: "info", label: "Sustainability" }}
                description="Our code follows industry best practices, ensuring your project is easy to maintain and extend."
              />
            </MKBox>
          </Grid>
        </Grid>
      </Container>
    </MKBox>
  );
}

export default Team;
